import React from 'react';
import { BudgetSchedulesSearch } from 'components';

export const LineItemSearchPage = () => {
    return <BudgetSchedulesSearch />;
};
